import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsStore {
  showOrderMarks: boolean;
  showOrderConfirm: boolean;
  showScaleOrderConfirm: boolean;
  showClosePositionConfirm: boolean;
  showLimitsBreachConfirm: boolean;
  showPositionMarketPnL: boolean;
  showEstClosePrice: boolean | null;
  showEstFillPrice: boolean | null;
  showTpslLines: boolean;
  hideInactiveAccounts: boolean;
  preserveMarketOrderFormOnCreate: boolean;
}

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (_) => ({
      showOrderMarks: true,
      showOrderConfirm: true,
      showScaleOrderConfirm: true,
      showClosePositionConfirm: true,
      showLimitsBreachConfirm: true,
      showPositionMarketPnL: true,
      showEstClosePrice: null,
      showEstFillPrice: null,
      showTpslLines: true,
      hideInactiveAccounts: false,
      preserveMarketOrderFormOnCreate: false,
    }),
    {
      name: 'settings',
    },
  ),
);
